// angular
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
// firebase
import {AngularFireModule} from '@angular/fire';
import {AngularFirestoreModule} from "@angular/fire/firestore";
import {AngularFireRemoteConfigModule, SETTINGS} from '@angular/fire/remote-config';
// environment
import {environment} from '../env/environment';
// apps
import {AppComponent} from './app.component';
import { AdminRoutingModule } from './admin.routing';
import {AppRoutingModule} from './app.routing';

// - guards
import {ExistClientIdGuard} from "./guards/exist-client-id-guard";
import {NotProductionGuard} from "./guards/not-production-guard";
import {LoginUserTermsAgreedGuard} from "./guards/login-user-terms-agreed-guard";
// - modules
import {PartsModule} from "./parts/parts.module";
import { ToastrModule } from 'ngx-toastr';
// - pages
import {AdminPageComponent} from "./pages/admin/admin-page.component";
import {DebugPageComponent} from "./pages/debug/debug-page.component";
import {IndexPageComponent} from "./pages/index/index-page.component";
import {LiveTermsPageComponent} from "./pages/terms/live-terms-page.component";
import {MagazinePageComponent} from "./pages/magazines/magazine-page.component";
import {NotFoundPageComponent} from "./pages/error/not-found-page.component";
import {ServerErrorPageComponent} from "./pages/error/server-error-page.component";
import {LivePageComponent} from './pages/lives/live-page.component';
import {ViewPageComponent} from "./pages/view/view-page.component";
import {FirestoreAccess} from "../lib/firestore-access";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {EncodeuriPipe} from './encodeuri.pipe'
import {mag2RemoteConfig} from "../lib/mag2-remote-config";
import { CookieService } from 'ngx-cookie-service';
import { PointManagePageComponent } from './pages/point/point-manage-page.component';
import { RevenueManagePageComponent } from './pages/revenue/revenue-manage-page.component';
import { ConsoleLogger } from 'src/lib/console-logger';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common'
import { ClipboardModule } from '@angular/cdk/clipboard'

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    // firebase
    AngularFireModule.initializeApp(environment.firebase, 'maglive-dev-518d8'), // imports firebase/app needed for everything
    AngularFirestoreModule,
    AngularFireRemoteConfigModule,
    // other
    PartsModule,
    AdminRoutingModule,
    AppRoutingModule,
    InfiniteScrollModule,
    ClipboardModule,
  ],
  declarations: [
    AppComponent,
    // pages
    AdminPageComponent,
    DebugPageComponent,
    IndexPageComponent,
    LiveTermsPageComponent,
    MagazinePageComponent,
    NotFoundPageComponent,
    ServerErrorPageComponent,
    LivePageComponent,
    ViewPageComponent,
    EncodeuriPipe,
    PointManagePageComponent,
    RevenueManagePageComponent,
  ],
  providers: [
    FirestoreAccess,
    ExistClientIdGuard,
    NotProductionGuard,
    LoginUserTermsAgreedGuard,
    CookieService,
    // remote-config
    mag2RemoteConfig,
    ConsoleLogger,
    {provide: SETTINGS, useValue: { minimumFetchIntervalMillis: 300_000 }}, // TODO: prod時は3600_000にする
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
